import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import {
  EmptyBooking,
  EmptyInbox,
  EmptyNft,
  EmptyProperty,
  UnVerified,
  VerifyUserIcon,
  UserBoxIcon,
  LightIcon,
} from "../../AssetComponents/Images"
import { useIsMobile } from './UseIsMobile'
// import { EmptyBooking } from '../../AssetComponents/Images'
import { BlackButton } from "../../Components/Buttons/BlackButton"
import { PurpleButton } from "../../Components/Buttons/PurpleButton"
import { RentalItem } from "../../Components/RealEstateProperty/RentalItem"
import { SelectionGroup, SelectionItem } from "../../Components/Selection/Selection"
import Tick from "../../assets/images/Dashboard/Dashboard/Tick"
// import { StaticHostSidebar } from "./SideBar"
import { StaticHostSidebar } from './Dashboard/SideBar'
import { OnboardingProvider, useOnboarding } from './OnBoarding1'
import Logo1 from '../../assets/images/logoForQRcode.svg'
// import { toast } from '../Toast'
import Modal from 'react-responsive-modal'

// Static data
const staticProfile = {
  Avatar: "/placeholder.svg?height=80&width=80",
  Name: "WELHOME",
  ID: "verified/true/user",
}

const staticNfts = [
  {
    token_id: "1",
    metaData: {
      buildingName: "Luxury Apartment Downtown",
      images: ["/placeholder.svg?height=200&width=300"],
    },
  },
  {
    token_id: "2",
    metaData: {
      buildingName: "Modern Studio Apartment",
      images: ["/placeholder.svg?height=200&width=300"],
    },
  },
]

const staticNotifications = [
  {
    type: "event",
    data: {
      sender: "0x1234...5678",
      action: "finalize_short_term_rental",
      token_id: "1",
      timeUTC: "2024-01-15T14:30:00Z",
    },
  },
  {
    type: "message",
    data: {
      id: "msg1",
      nftId: "1",
      message: {
        sender: "0x9876...5432",
        generatedTime: "2024-01-14T11:45:00Z",
      },
    },
  },
]

const staticProfiles = {
  "0x1234...5678": {
    Avatar: "/placeholder.svg?height=44&width=44",
    Name: "John Doe",
  },
  "0x9876...5432": {
    Avatar: "/placeholder.svg?height=44&width=44",
    Name: "Sarah Miller",
  },
}

const formatDate = (timestamp) => {
  try {
    const date = new Date(timestamp)
    if (isNaN(date.getTime())) {
      return "Invalid date"
    }
    return new Intl.DateTimeFormat("en-US", {
      day: "numeric",
      month: "short",
    }).format(date)
  } catch (error) {
    console.error("Error formatting date:", error)
    return "Invalid date"
  }
}

const formatTime = (timestamp) => {
  try {
    const date = new Date(timestamp)
    if (isNaN(date.getTime())) {
      return "Invalid time"
    }
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date)
  } catch (error) {
    console.error("Error formatting time:", error)
    return "Invalid time"
  }
}

const parseAction = (action) => {
  switch (action) {
    case "finalize_short_term_rental":
      return (
        <div className="flex items-center">
          <div className="text-[#38A569]">Completed</div>
        </div>
      )
    case "set_reservation_for_short_term":
      return (
        <div className="flex items-center">
          <div className="text-[#38A569]">Reserved</div>
        </div>
      )
    case "cancel_reservation_for_shortterm":
      return (
        <div className="flex items-center">
          <div className="text-[#DB1F22]">Canceled</div>
        </div>
      )
    case "cancel_rental_for_shortterm":
      return (
        <div className="flex items-center">
          <div className="text-[#DB1F22]">Canceled</div>
        </div>
      )
    case "reject_reservation_for_shortterm":
      return (
        <div className="flex items-center">
          <div className="text-[#DB1F22]">Rejected</div>
        </div>
      )
    default:
      break
  }
}

const truncateWalletAddress = (address) => {
  if (!address) return ""
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}

// Create a wrapper component that provides the onboarding context
export const HostDashboard1 = () => {
  return (
    <OnboardingProvider>
      <StaticHostDashboard1 />
    </OnboardingProvider>
  )
}

// Keep the existing component but rename it to avoid conflicts
const StaticHostDashboard1 = () => {
  const [searchParams] = useSearchParams()
  const [showVerificationModal, setShowVerificationModal] = useState(false)
  const [showWelcomeModal, setShowWelcomeModal] = useState(true) // Add welcome modal state
  const { isOnboarding, currentStep, nextStep, prevStep, skipOnboarding, completeOnboarding, setCurrentStep, startOnboarding, showConfirmModal, pendingNavigation, requestTourSwitch, confirmTourSwitch, cancelTourSwitch } = useOnboarding()
  const navigate = useNavigate()
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const isMobile = useIsMobile();
  const currentProfile = staticProfile
  const myNfts = staticNfts
  const notificationContent = staticNotifications
  const profiles = staticProfiles
  const flag = 0 // Default to "Upcoming" tab

  // Check if returning from completion screen OR ensure welcome modal shows on fresh start
  useEffect(() => {
    const lastStep = sessionStorage.getItem('hostOnboardingLastStep');
    const fromCompletion = sessionStorage.getItem('hostOnboardingFromCompletion');
    const stepParam = searchParams.get('step');
    
    // If coming back from completion screen and no step param, navigate to last step
    if (fromCompletion === 'true' && lastStep && !stepParam) {
      const stepNum = parseInt(lastStep, 10);
      if (!isNaN(stepNum)) {
        console.log('Returning from completion screen, navigating to step:', stepNum);
        setShowWelcomeModal(false);
        // Navigate to the correct URL with step param (this will trigger the second useEffect)
        navigate(`/onboarding/host1?step=${stepNum}`, { replace: true });
        // Clear the flag so it doesn't trigger again
        sessionStorage.removeItem('hostOnboardingFromCompletion');
        return; // Exit early to avoid other logic
      }
    }
    
    // If there's a step param AND we're coming from completion, clear completion flag
    if (stepParam && fromCompletion === 'true') {
      sessionStorage.removeItem('hostOnboardingFromCompletion');
      setShowWelcomeModal(false);
      return; // Exit early
    }
    
    // Fresh start - show welcome modal if:
    // 1. No step param in URL
    // 2. Not coming from completion
    // 3. Not already in onboarding
    if (!stepParam && fromCompletion !== 'true' && !isOnboarding) {
      console.log('Fresh start - showing welcome modal');
      setShowWelcomeModal(true);
    }
  }, [searchParams, navigate, isOnboarding]);

  useEffect(() => {
    // Check if coming from onboarding step 9, 10, or 11
    const stepParam = searchParams.get('step')
    
    console.log('HostDashboard useEffect - stepParam:', stepParam, 'currentStep:', currentStep, 'isOnboarding:', isOnboarding);
    
    // If there's a step param, we're continuing/returning to onboarding, so skip welcome modal
    if (stepParam) {
      setShowWelcomeModal(false);
    }
    
    if (stepParam === '10') {
      // This is actually step 9 in the onboarding flow (sidebar)
      if (!isOnboarding) {
        console.log('Starting onboarding and setting to step 9');
        startOnboarding()
        setCurrentStep(9) // Set to step 9 (sidebar)
      }
      // Ensure we're on step 9
      if (currentStep !== 9 && isOnboarding) {
        console.log('Setting currentStep to 9');
        setCurrentStep(9)
      }
      setShowVerificationModal(false)
    }
    else if (stepParam === '11') {
      // This is actually step 10 in the onboarding flow (verification)
      if (!isOnboarding) {
        console.log('Starting onboarding and setting to step 10');
        startOnboarding()
        setCurrentStep(10) // Set to step 10 (verification)
      }
      // Ensure we're on step 10
      if (currentStep !== 10 && isOnboarding) {
        console.log('Setting currentStep to 10');
        setCurrentStep(10)
      }
      setShowVerificationModal(false)
    }
    else if (stepParam === '12') {
      // This is actually step 11 in the onboarding flow (trips overview)
      if (!isOnboarding) {
        console.log('Starting onboarding and setting to step 11');
        startOnboarding()
        setCurrentStep(11) // Set to step 11 (trips overview)
      }
      // Ensure we're on step 11
      if (currentStep !== 11 && isOnboarding) {
        console.log('Setting currentStep to 11');
        setCurrentStep(11)
      }
      setShowVerificationModal(false)
    }
    else if(stepParam === "13"){
      if(!isOnboarding){
        startOnboarding();
        setCurrentStep(13);
      }
      if(currentStep !== 13 && isOnboarding){
        setCurrentStep(13);
      }
      setShowVerificationModal(false);
    }
    else if(stepParam === "14"){
      if(!isOnboarding){
        startOnboarding();
        setCurrentStep(14);
      }
      if(currentStep != 14 && isOnboarding){
        setCurrentStep(14);
      }
      setShowVerificationModal(false);
    }
  else if(stepParam === "15"){
  if(!isOnboarding){
    startOnboarding();
    setCurrentStep(15);
  }
  if(currentStep != 15 && isOnboarding){
    setCurrentStep(15);
  }
  setShowVerificationModal(false);
}
    // Check if coming from onboarding completion
    else if (!stepParam && searchParams.get('showVerification') === 'true') {
      setShowVerificationModal(true)
    }
  }, [searchParams, isOnboarding, currentStep, startOnboarding, setCurrentStep])

  const handleSkipOnboarding = () => {
    // localStorage.setItem('hasSeenOnboarding', 'true');
    skipOnboarding();
    navigate('/dashboard/host/dashboard');
  };

  const VerificationModal = () => {
    if (!showVerificationModal) return null

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100000]">
        <div className="bg-white rounded-[10px] p-6 max-w-md w-full mx-4 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] onboarding-highlight z-[100001]" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
          <div className="space-y-6">
            <div className="text-center">
              <h2 className="text-2xl font-semibold">Welcome to Hosting!</h2>
              <p className="text-[#666666] mt-2">Complete your verification to start hosting properties</p>
            </div>

            <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-4 h-4 bg-purple-500 rounded-full"></div>
                <div className="font-semibold text-purple-800">Onboarding Complete!</div>
              </div>
              <div className="text-sm text-purple-700">
                Great job completing the tour! Now let's get you verified so you can start hosting properties
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
                <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-bold">1</span>
                </div>
                <div>
                  <div className="font-semibold">Verify Your Profile</div>
                  <div className="text-sm text-[#666666]">Upload your personal information</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-bold">2</span>
                </div>
                <div>
                  <div className="font-semibold">Emirates ID Verification</div>
                  <div className="text-sm text-[#666666]">Upload your Emirates ID for verification</div>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-yellow-500 rounded-full"></div>
                <div className="font-semibold text-yellow-800">Important</div>
              </div>
              <div className="text-sm text-yellow-700 mt-1">
                You need to complete verification before you can start hosting properties on our platform
              </div>
            </div>

            <div className="flex gap-3">
              <BlackButton 
                text="Later" 
                onClick={() => setShowVerificationModal(false)}
                className="flex-1"
              />
              <PurpleButton 
                text="Start Verification"
                onClick={() => {
                  setShowVerificationModal(false)
                  // Scroll to verification section
                  document.getElementById('verify-nfts-section')?.scrollIntoView({ behavior: 'smooth' })
                }}
                className="flex-1"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Welcome modal handlers
  const handleSkip = () => {
    setShowWelcomeModal(false)
    skipOnboarding()
    navigate('/dashboard/host/dashboard')
  }
  const handleNext = () => {
    setShowWelcomeModal(false)
    startOnboarding()
    setCurrentStep(9)
    // Clear any completion flags when starting fresh
    sessionStorage.removeItem('hostOnboardingFromCompletion');
    sessionStorage.removeItem('hostOnboardingLastStep');
    // Navigate to include step param for consistency
    navigate('/onboarding/host1?step=10', { replace: true });
  }

  return (
    <div className="flex h-screen">
   
   {showWelcomeModal && (
  <Modal
    open={true}
    center
    onClose={() => {}}
    showCloseIcon={false}
    classNames={{
      modal:
        "rounded-xl border-none shadow-2xl onboarding-highlight overflow-hidden max-w-[95vw] sm:max-w-lg bg-white",
    }}
    styles={{
      modal: { 
        zIndex: 100000, 
        padding: 0,
        backgroundColor: '#ffffff',
        background: '#ffffff',
        opacity: 1,
      },
    }}
  >
    <div className="relative">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 p-6 sm:p-8 text-center text-white">
        <div className="flex justify-center mb-4 sm:mb-6">
          <div className="bg-white rounded-full p-3 sm:p-4">
            <img src={Logo1} alt="CodedEstate Logo" className="w-12 h-12 sm:w-16 sm:h-16" />
          </div>
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold mb-1 sm:mb-2">
          Welcome to Hosting on CodedEstate!
        </h1>
        <p className="text-purple-100 text-base sm:text-lg">
          Unlock the future of real estate rentals as a Host
        </p>
      </div>

      {/* Content */}
      <div className="p-4 sm:p-8 bg-white">
        <div className="text-center mb-4 sm:mb-8">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
            Why become a Host on CodedEstate?
          </h2>
          {/* Hide this paragraph on very small screens */}
          <p className="hidden sm:block text-gray-600 leading-relaxed">
            List your property, earn crypto, and manage bookings with ease 
            As a host, you get access to powerful features:
          </p>
        </div>

        {/* Feature highlights – hide 2nd column on mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6 sm:mb-8">
          <div className="text-left">
            <ul className="list-disc pl-4 text-gray-700 space-y-2 text-sm">
              <li><span className="font-semibold text-purple-700">List properties</span> and reach global guests</li>
              <li><span className="font-semibold text-purple-700">Earn crypto & fiat</span> with secure payments</li>
              <li className="hidden sm:list-item"><span className="font-semibold text-purple-700">Mint Real Estate NFTs</span> for your listings</li>
              <li><span className="font-semibold text-purple-700">Manage bookings</span> from your dashboard</li>
            </ul>
          </div>
          <div className="hidden sm:block text-left">
            <ul className="list-disc pl-4 text-gray-700 space-y-2 text-sm">
              <li><span className="font-semibold text-purple-700">Reduced fees</span>  no intermediaries</li>
              <li><span className="font-semibold text-purple-700">Secure blockchain</span> for all transactions</li>
              <li><span className="font-semibold text-purple-700">Global reach</span>  attract guests worldwide</li>
              <li><span className="font-semibold text-purple-700">Inbox & messaging</span> with guests</li>
            </ul>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex flex-wrap gap-3 justify-center">
          <BlackButton 
            text="Skip Tour" 
            onClick={handleSkip}
            className="px-4 py-2 text-sm sm:px-6 sm:py-3 whitespace-nowrap"
          />
          <PurpleButton 
            text={
              <div className="flex items-center gap-2 whitespace-nowrap">
                <span>Start Hosting Tour</span>
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            }
            onClick={handleNext}
            className="px-4 py-2 text-sm sm:px-6 sm:py-3"
          />
        </div>

        {/* Bottom note – hide on very small screens */}
        <div className="hidden sm:block text-center mt-4 sm:mt-6">
          <p className="text-xs text-gray-500">
            This guided tour will show you how to maximize your hosting experience in under 2 minutes
          </p>
        </div>
      </div>
    </div>
  </Modal>
)}


    
      {!showWelcomeModal && (
        <>
        {isMobile ? (
          <>
             {showConfirmModal && currentStep === 11 && (
 <Modal
  open={true}
  center
  onClose={() => {}}
  showCloseIcon={false}
  classNames={{
    modal:
      " rounded-xl border-none shadow-2xl  onboarding-highlight overflow-hidden bg-white",
  }}
  styles={{
    modal: {
      zIndex: 100000,
      padding: "0",
      backgroundColor: '#ffffff',
      background: '#ffffff',
      opacity: 1,
    },
  }}
>
  <div className="relative">
    {/* Header */}
    <div className="bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 p-4 sm:p-3 text-center text-white">
      <div className="flex justify-center mb-3 sm:mb-2">
        <div className="bg-white rounded-full p-2 sm:p-1.5">
          <img
            src={Logo1}
            alt="CodedEstate Logo"
            className="w-10 h-10 sm:w-8 sm:h-8"
          />
        </div>
      </div>
      <h1 className="text-lg font-bold mb-1 sm:text-base">
        Welcome to Hosting on CodedEstate!
      </h1>
      <p className="text-purple-100 text-sm sm:text-xs">
        Unlock the future of real estate rentals as a Host
      </p>
    </div>

    {/* Content */}
    <div className="p-3 bg-white sm:p-2">
      <div className="text-center mb-3 sm:mb-2">
        <h2 className="text-base font-semibold text-gray-800 mb-1 sm:text-sm">
          Why become a Host on CodedEstate?
        </h2>
        <p className="text-gray-600 text-sm leading-snug sm:text-xs">
          List your property, earn crypto, and manage bookings with ease
        </p>
      </div>

      {/* Features */}
      <div className="grid grid-cols-1 gap-2 mb-4 sm:gap-1 sm:mb-3 text-left">
        <ul className="list-disc pl-5 text-gray-700 space-y-1 text-sm sm:text-xs">
          <li><span className="font-semibold text-purple-700">List properties</span> and reach global guests</li>
          <li><span className="font-semibold text-purple-700">Earn crypto & fiat</span> securely</li>
          <li><span className="font-semibold text-purple-700">Mint NFTs</span> for listings</li>
          <li><span className="font-semibold text-purple-700">Manage bookings</span> easily</li>
          <li><span className="font-semibold text-purple-700">Own your assets</span> directly</li>
          <li><span className="font-semibold text-purple-700">Reduced fees</span> – no middlemen</li>
          <li><span className="font-semibold text-purple-700">Blockchain-secure</span> transactions</li>
          <li><span className="font-semibold text-purple-700">Global reach</span> to guests</li>
          <li><span className="font-semibold text-purple-700">Messaging</span> with guests</li>
          <li><span className="font-semibold text-purple-700">Insights & alerts</span> for your rentals</li>
        </ul>
      </div>

      {/* Buttons */}
      <div className="flex justify-center gap-2 flex-wrap text-sm sm:text-xs">
        <BlackButton
          text="Skip Tour"
          onClick={handleSkip}
          className="px-4 py-1.5 sm:px-3 sm:py-1"
        />
        <PurpleButton
          text={
            <div className="flex items-center gap-1">
              <span>Start Tour</span>
              <svg
                className="w-3 h-3"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          }
          onClick={handleNext}
          className="px-4 py-1.5 sm:px-3 sm:py-1"
        />
      </div>

      {/* Footer */}
      <div className="text-center mt-3">
        <p className="text-xs text-gray-500 sm:text-[10px]">
          This tour shows how to host in under 2 minutes
        </p>
      </div>
    </div>
  </div>
</Modal>

          )}
          
          {isOnboarding && currentStep === 9 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99999] pointer-events-none" />
          )}
          
     
          {isOnboarding && currentStep === 10 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99999] pointer-events-none" />
          )}

        
          {isOnboarding && currentStep === 11 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99999] pointer-events-none" />
          )}
          
          <div className={`relative ${isOnboarding && currentStep === 9 ? 'ring-4 ring-purple-500 ring-opacity-50' : ''}`}>
            <StaticHostSidebar />
            
            {/* Step 9 Sidebar Onboarding Modal - Extra compact */}
            {isOnboarding && currentStep === 9 && (
  <div className="absolute top-16 left-[70px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="p-3">
                  <div className="text-center mb-3">
                    <h3 className="text-base font-semibold">Navigation Sidebar</h3>
                    <p className="text-xs text-[#666666] mt-1">Your menu for key features</p>
                  </div>

                  <div className="bg-purple-50 p-2 rounded-lg border border-purple-200 mb-3">
                    <div className="flex items-center gap-1 mb-1">
                      <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                      <div className="text-xs font-semibold text-purple-800">Host Navigation</div>
                    </div>
                    <div className="text-[10px] text-purple-700">
                      Your home base for hosting
                    </div>
                  </div>

                  <div className="space-y-1 mb-3">
                    <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
                      <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Dashboard</div>
                        <div className="text-[10px] text-[#666666]">Home base</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
                      <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Reservations</div>
                        <div className="text-[10px] text-[#666666]">Bookings</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 p-1.5 bg-yellow-50 rounded">
                      <div className="w-4 h-4 bg-yellow-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Transactions</div>
                        <div className="text-[10px] text-[#666666]">Payments</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 p-1.5 bg-red-50 rounded">
                      <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Inbox</div>
                        <div className="text-[10px] text-[#666666]">Messages</div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-2 rounded border border-purple-200 mb-3">
                    <div className="flex items-center gap-1 mb-1">
                      <div className="w-2 h-2 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full"></div>
                      <div className="text-xs font-semibold text-purple-800">Role Switcher</div>
                    </div>
                    <div className="text-[10px] text-purple-700">
                      🔄 Switch Host/Traveler at bottom
                    </div>
                  </div>

                  {/* Purple arrow pointing to the sidebar */}
                  <div className="absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>

                  <div className="flex gap-1 justify-center">
                    {/* <BlackButton 
                      text="Back" 
                      onClick={() => {
                        navigate('/onboarding/steps'); 
                        prevStep();
                      }}
                      className="flex-1 text-xs py-1.5 px-2"
                    /> */}
                    <PurpleButton 
                      text="Next"
                      onClick={() => {
                        navigate('/onboarding/host1?step=11'); // Go to step 11 (verification)
                        nextStep();
                      }}
                           className="flex-1 text-xs py-1.5 px-3"
                    />
                    <button 
                      onClick={handleSkipOnboarding}
                      className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                    >
                      Skip
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="flex-1 select-none w-full overflow-auto max-h-[calc(100vh-80px)] h-full p-[10px]">
<div className="w-full h-full space-y-[20px] rounded-[10px] p-[8px] flex flex-col">
  <div className="bg-white border-[2px] h-max border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
    <div className="font-semibold text-[24px]">Dashboard</div>
    <div className="text-[#666666] font-normal">Welcome to the Coded Estate Dashboard</div>
  </div>

    <div className="w-full lg:hidden mb-6"> 
  <div className="mb-4 w-full lg:min-w-[300px] lg:w-[300px]">
              <div 
    id="verify-nfts-section"
     className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
        isOnboarding && currentStep === 10 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
      }`}
    >
                  <div className="font-semibold">Verify NFTs</div>
                 <div className={`bg-white flex flex-col justify-around p-2 items-center border-[2px] h-full w-full border-[#E3E3E3] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
        isOnboarding && currentStep === 10 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
      }`}>
                    {currentProfile?.Avatar ? (
                      <img
                        alt=""
                        src={currentProfile?.Avatar || "/placeholder.svg"}
                        className="w-[80px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      />
                    ) : (
                      <VerifyUserIcon />
                    )}
                    {currentProfile?.Name ? (
                      <div className="font-semibold">{currentProfile?.Name?.replace("/", " ")}</div>
                    ) : (
                      <div className="font-semibold">Unknown</div>
                    )}
                    {currentProfile?.isVerified ? (
                      <div className="flex items-center">
                        <Tick />
                        <div className="text-[#959595] font-normal text-[14px]">Verified Account</div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-[10px]">
                        <UnVerified />
                        <div className="text-[#959595] font-normal text-[14px]">Unverified Account</div>
                      </div>
                    )}
                    {currentProfile?.isVerified ? (
                      <div className="w-full">
                        <PurpleButton text={<div className="w-full text-center">Your Profile</div>} />
                      </div>
                    ) : (
                      <div className="w-full">
                        <BlackButton 
                          text={<div className="w-full text-center">Verify now</div>}
                          onClick={() => setShowVerificationModal(true)}
                        />
                      </div>
                    )}
                  </div>
                  
                  
{isOnboarding && currentStep === 10 && (
  <div className="absolute mt-40  top-full left-4 mt-4 sm:left-4 sm:top-full sm:mt-4 lg:left-[320px] lg:top-0 lg:mt-0 w-[calc(100vw-2rem)] max-w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
                          <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Profile Verification</h3>
        <p className="text-xs text-[#666666] mt-1">Verify to start hosting</p>
      </div>

                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Final Step!</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Profile Card shows verification status
        </div>
      </div>

                       <div className="space-y-2 mb-3">
        <div className="bg-blue-50 p-2 rounded border border-blue-200">
          <div className="flex items-center gap-1 mb-1">
            <div className="w-3 h-3 bg-blue-500 rounded-full flex items-center justify-center">
              <span className="text-white text-[8px] font-bold">ℹ</span>
            </div>
            <div className="text-xs font-semibold text-blue-800">Profile</div>
          </div>
          <div className="text-[10px] text-blue-700">
            Click "Verify now" to connect wallet
          </div>
        </div>
  <div className="bg-yellow-50 p-2 rounded border border-yellow-200">
          <div className="flex items-center gap-1 mb-1">
            <div className="w-3 h-3 bg-yellow-500 rounded-full flex items-center justify-center">
              <span className="text-white text-[8px] font-bold">!</span>
            </div>
            <div className="text-xs font-semibold text-yellow-800">Required</div>
          </div>
          <div className="text-[10px] text-yellow-700">
            Need for platform security
          </div>
        </div>
      </div>

                         <div className="bg-green-50 p-2 rounded border border-green-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
          <div className="text-xs font-semibold text-green-800">You'll Need</div>
        </div>
        <div className="text-[10px] text-green-700 space-y-0.5">
          <div>• Emirates ID</div>
          <div>• Crypto wallet</div>
          <div>• Personal info</div>
        </div>
      </div>

                          <div className="hidden lg:block absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>

                           <div className="flex gap-1  justify-center">
        <BlackButton 
          text="Back" 
          onClick={() => {
            navigate('/onboarding/host1?step=10');
            setCurrentStep(9);
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
                            <PurpleButton 
          text="Next"
          onClick={() => {
            navigate('/onboarding/host1?step=12');
            setCurrentStep(11);
          }}
         
        />
                           <button 
          onClick={handleSkipOnboarding}
          className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
        >
          Skip
        </button>
      </div>
    </div>
  </div>
)}
                </div>

                </div>

                


     <div className="w-full lg:hidden mb-6">
    <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
      isOnboarding && currentStep === 14 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
    }`}>
                       <div className="font-semibold">Your Minted NFTs</div>
      <div className="w-full min-h-[200px] max-h-[280px] bg-white p-2 border-[2px] border-[#E3E3E3] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] overflow-hidden">
        {/* ...existing minted NFTs content... */}
        <div className="pb-1 flex gap-[10px] items-center overflow-auto scrollbarwidth w-full h-full">
                      {myNfts.map((nft, i) => (
                        <div key={i} className="w-max h-max relative group">
                          <RentalItem
                            showArrow={false}
                            token_id={nft.token_id}
                            tokenData={nft}
                            imageHeight={200}
                            onlyImages
                          />
                          <div className="group-hover:flex absolute top-0 left-0 w-full h-full hidden flex-col items-center justify-center">
                            <BlackButton text="View" />
                          </div>
                        </div>
                      ))}
                    </div>
                    {myNfts.length === 0 && (
                      <div className="flex flex-col justify-center items-center h-full w-full px-[100px] text-center">
                        <EmptyProperty />
                        <div className="font-semibold">You have no properties yet</div>
                      </div>
                    )}
                  </div>
{isOnboarding && currentStep === 14 && !showCompletionModal && (
  <div className="absolute -top-[360px] left-4 sm:left-4 sm:-top-[320px] lg:left-[380px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Your Minted NFTs</h3>
        <p className="text-xs text-[#666666] mt-1">
          Here your minted properties will be seen. Mint your property NFT and start hosting
        </p>
      </div>
      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Mint Property</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Minting an NFT lets you list your property on CodedEstate and unlock hosting features
        </div>
      </div>
      <div className="space-y-1 mb-3">
        <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
          <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Start Hosting</div>
            <div className="text-[10px] text-[#666666]">Mint your property and begin earning</div>
          </div>
        </div>
        <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
          <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Direct Ownership</div>
            <div className="text-[10px] text-[#666666]">Control your assets securely</div>
          </div>
        </div>
      </div>
      {/* Arrow pointing down to minted NFTs section on mobile, left on desktop */}
      <div className="block sm:block lg:hidden absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[12px] border-r-[12px] border-t-[16px] border-l-transparent border-r-transparent border-t-purple-500"></div>
      <div className="hidden lg:block absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
      <div className="flex gap-1  justify-center">
        <BlackButton 
          text="Back" 
          onClick={() => {
            setCurrentStep(13);
            navigate('/onboarding/host1?step=13');
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
       <PurpleButton 
  text="Next"
 onClick={() => {
navigate('/onboarding/host1?step=15');
  }}

/>
      </div>
    </div>
  </div>
)}
                </div>
</div>

 <div className="w-full lg:hidden mb-6">
    <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
      isOnboarding && currentStep === 11 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
    }`}>
                   <div className="font-semibold">Booking request</div>
      <div className={`border-[2px] border-[#E3E3E3] h-full bg-white p-2 top-0 overflow-auto w-full rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
        isOnboarding && currentStep === 11 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
      }`}>
                   <div className="w-full justify-between flex items-center gap-4">
          <SelectionGroup
            defaultItem={flag}
            className={`border-[2px] border-[#e3e3e3] w-max px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
              isOnboarding && currentStep === 11 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
            }`}
          >
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Upcoming</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Upcoming</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Current</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Current</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Completed</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Completed</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Cancelled</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Cancelled</div>
                            </div>
                          }
                        />
                      </SelectionGroup>
                    </div>
                    <div className="flex gap-2 items-center mt-1 pb-1 w-full overflow-auto scrollbarwidth">
          <div className="flex flex-col items-center w-full justify-center h-full">
            <EmptyBooking />
            <div>No reservations yet</div>
            <div className="text-[#737373]">No upcoming reservations yet</div>
          </div>
                    </div>
                  </div>

             
   {isOnboarding && currentStep === 11 && !showConfirmModal && (
  <div className="absolute -top-[497px] left-4 sm:left-4 sm:-top-[320px] lg:-left-[300px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Booking Management</h3>
        <p className="text-xs text-[#666666] mt-1">Track all your reservations</p>
      </div>

      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Booking Management</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Center panel includes tabs for all your reservations
        </div>
      </div>

      <div className="space-y-1 mb-3">
        <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
          <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Upcoming</div>
            <div className="text-[10px] text-[#666666]">View your next booked stays</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
          <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Current</div>
            <div className="text-[10px] text-[#666666]">See ongoing reservations</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2 p-1.5 bg-gray-50 rounded">
          <div className="w-4 h-4 bg-gray-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Completed</div>
            <div className="text-[10px] text-[#666666]">Review past stays</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2 p-1.5 bg-red-50 rounded">
          <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Cancelled</div>
            <div className="text-[10px] text-[#666666]">Access booking history</div>
          </div>
        </div>
      </div>

      <div className="bg-green-50 p-2 rounded border border-green-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
          <div className="text-xs font-semibold text-green-800">Travel Activity</div>
        </div>
        <div className="text-[10px] text-green-700">
          This is where you'll track all your travel activity on the platform
        </div>
      </div>

      {/* Arrow pointing down to booking section on mobile, right on desktop */}
      <div className="block sm:block lg:hidden absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[12px] border-r-[12px] border-t-[16px] border-l-transparent border-r-transparent border-t-purple-500"></div>
      <div className="hidden lg:block absolute top-1/2 -right-4 w-0 h-0 border-l-[16px] border-t-[12px] border-b-[12px] border-l-purple-500 border-t-transparent border-b-transparent"></div>

      <div className="flex gap-1  justify-center">
        <BlackButton 
          text="Back" 
          onClick={() => {
            navigate('/onboarding/host1?step=11');
            prevStep();
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
        <PurpleButton 
          text="Next"
          onClick={()=>{navigate('/onboarding/host1?step=13');
            nextStep();
          }}
       
        />
      </div>
    </div>
  </div>
)}
                </div>
</div>

              </div>

 <div className="w-full lg:hidden mb-6">
    <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
      isOnboarding && currentStep === 13
        ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50 onboarding-highlight'
        : ''
    }`}>
    <div className="font-semibold">Mint Your Real Estate NFT</div>
      <div className="bg-white flex flex-col justify-center items-center border-[2px] h-[200px] sm:h-[300px] w-full border-[#E3E3E3] p-[12px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
        <div className="scale-75 sm:scale-100 mb-2">
          <EmptyNft />
        </div>
        <div className="flex flex-col items-center mb-2">
          <div className="font-semibold text-sm sm:text-base">No NFT's minted yet</div>
          <div className="text-[#959595] font-normal text-[12px] sm:text-[14px] text-center">Your NFT minted is empty yet</div>
        </div>
        <PurpleButton text={<div className="min-w-[80px] text-center text-sm">Mint</div>} />
      </div>

 {isOnboarding && currentStep === 13 && (
  <div className="absolute -top-[320px] left-4 sm:left-4 sm:-top-[320px] lg:left-[380px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Mint Your Real Estate NFT</h3>
        <p className="text-xs text-[#666666] mt-1">Mint your property NFT and start hosting</p>
      </div>
      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Mint Property</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Minting an NFT lets you list your property on CodedEstate and unlock hosting features
        </div>
      </div>
      <div className="space-y-1 mb-3">
        <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
          <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Start Hosting</div>
            <div className="text-[10px] text-[#666666]">Mint your property and begin earning</div>
          </div>
        </div>
        <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
          <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Direct Ownership</div>
            <div className="text-[10px] text-[#666666]">Control your assets securely</div>
          </div>
        </div>
      </div>
      
      {/* Arrow pointing down to mint section on mobile, left on desktop */}
      <div className="block sm:block lg:hidden absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[12px] border-r-[12px] border-t-[16px] border-l-transparent border-r-transparent border-t-purple-500"></div>
      <div className="hidden lg:block absolute top-[120px] -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
      
      <div className="flex gap-1  justify-center">
        <BlackButton 
          text="Back" 
          onClick={() => {
            setCurrentStep(11);
            navigate('/onboarding/host1?step=12');
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
        <PurpleButton 
          text="Next"
          onClick={()=>{navigate("/onboarding/host1?step=14")}}

        />
      </div>
    </div>
  </div>
)}
</div>

   <div className="w-full lg:hidden mb-6">
    <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
      isOnboarding && currentStep === 15
        ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50 bg-purple-50'
        : ''
    }`}>
  <div className="font-semibold">Notifications</div>

      {notificationContent.length > 0 ? (
        <div className="bg-white space-y-[4px] border-[2px] h-full w-full overflow-auto border-[#E3E3E3] p-[8px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] scrollbarwidth">
      {notificationContent.map((notif, idx) => (
        <div key={idx} className="flex items-center justify-between p-2 border-b last:border-b-0">
          {/* Render your notification item here */}
          <div>
            {notif.type === "event" ? (
              <span>
                {profiles[notif.data.sender]?.Name || notif.data.sender} {parseAction(notif.data.action)}
              </span>
            ) : (
              <span>
                {profiles[notif.data.message.sender]?.Name || notif.data.message.sender} Sent new message
              </span>
            )}
          </div>
          <div className="text-xs text-gray-500">
            {notif.type === "event"
              ? formatDate(notif.data.timeUTC) + " " + formatTime(notif.data.timeUTC)
              : formatDate(notif.data.message.generatedTime) + " " + formatTime(notif.data.message.generatedTime)}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="bg-white flex flex-col justify-around items-center border-[2px] h-[220px] sm:h-[300px] w-full border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
          <EmptyInbox />
          <div className="flex flex-col items-center">
            <div className="font-semibold">No notifications yet</div>
            <div className="text-[#959595] font-normal text-[14px]">Your inbox is empty yet</div>
          </div>
          <PurpleButton text={<div className="min-w-[100px] text-center">Inbox</div>} />
        </div>
  )}

{isOnboarding && currentStep === 15 && !showCompletionModal && (
  <div className="absolute -top-[430px] left-4 sm:left-4 sm:-top-[320px] lg:left-[-300px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Notifications</h3>
        <p className="text-xs text-[#666666] mt-1">
          All your platform notifications, messages, and updates will appear here. Stay informed about bookings, messages, and platform alerts
        </p>
      </div>
      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Stay Updated</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Check this panel regularly for important updates and guest messages
        </div>
      </div>
      
      <div className="space-y-1 mb-3">
        <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
          <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M15 17h5l-5 5-5-5h5v-5a6 6 0 1 0-6-6H4a8 8 0 1 1 8 8v5z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Real-time Updates</div>
            <div className="text-[10px] text-[#666666]">Get instant notifications for bookings</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
          <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Guest Messages</div>
            <div className="text-[10px] text-[#666666]">Direct communication with guests</div>
          </div>
        </div>
        
        <div className="flex items-center gap-2 p-1.5 bg-purple-50 rounded">
          <div className="w-4 h-4 bg-purple-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Platform Alerts</div>
            <div className="text-[10px] text-[#666666]">Important system notifications</div>
          </div>
        </div>
      </div>
      
      {/* Arrow pointing down to notifications section on mobile, right on desktop */}
      <div className="block sm:block lg:hidden absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[12px] border-r-[12px] border-t-[16px] border-l-transparent border-r-transparent border-t-purple-500"></div>
      <div className="hidden lg:block absolute top-1/2 -right-4 w-0 h-0 border-l-[16px] border-t-[12px] border-b-[12px] border-l-purple-500 border-t-transparent border-b-transparent"></div>
      
      <div className="flex gap-1">
        <BlackButton 
          text="Back" 
          onClick={() => {
            setCurrentStep(14);
            navigate('/onboarding/host1?step=14');
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
        <PurpleButton 
          text="Complete"
          onClick={() => {
            setCurrentStep(null);
            setShowCompletionModal(true);
          }}
   
        />
      </div>
    </div>
  </div>
)}
</div>
</div>





              </div>
            </div>
          </div>
{showCompletionModal && (
  <>
    <div 
      className="fixed inset-0 bg-black/50 z-[100000] flex items-center justify-center p-4"
      onClick={() => setShowCompletionModal(false)}
    >
      <div 
        className="w-[95vw] sm:w-[90vw] md:w-[480px] max-w-[480px] min-w-[280px] rounded-[12px] sm:rounded-[16px] bg-white shadow-xl border-0 p-0 z-[100001] max-h-[90vh] overflow-y-auto onboarding-highlight"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          margin: 0,
          padding: 0,
          backgroundColor: '#ffffff',
          background: '#ffffff',
          opacity: 1,
        }}
      >
        <div className="relative">
          <button
            onClick={() => setShowCompletionModal(false)}
            className="absolute top-3 right-3 sm:top-4 sm:right-4 p-1.5 sm:p-2 hover:bg-gray-100 rounded-full transition-colors z-10"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          <div className="text-center pt-6 sm:pt-8 pb-4 sm:pb-6 px-4 sm:px-6">
            <div className="flex justify-center mb-4 sm:mb-6">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r from-purple-500 to-purple-600 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 sm:w-10 sm:h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">Onboarding Complete!</h2>
              <p className="text-gray-600 text-sm sm:text-base mb-6 sm:mb-8 px-2">
                Congratulations! You've completed the hosting tour. Do you want to start hosting properties
              </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
        <BlackButton 
          text="Complete Onboarding" 
          onClick={() => {
            setShowCompletionModal(false);
            // Save the last step before navigating to completion
            sessionStorage.setItem('hostOnboardingLastStep', '15');
            sessionStorage.setItem('hostOnboardingFromCompletion', 'true');
            completeOnboarding();
            navigate('/rent/onboarding/Completion');
          }} 
          className="px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base order-2 sm:order-1"
        />
        <PurpleButton 
          text="Start Hosting"
          onClick={() => {
            setShowCompletionModal(false);
            // Save the last step before navigating
            sessionStorage.setItem('hostOnboardingLastStep', '15');
            sessionStorage.setItem('hostOnboardingFromCompletion', 'true');
            navigate('/dashboard/host/dashboard');
          }} 
          className="px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base order-1 sm:order-2"
        />
            </div>
            
            <div className="mt-4 sm:mt-6">
              <p className="text-xs sm:text-sm text-gray-500">
                You can always access hosting features from your dashboard later
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
)}

          <VerificationModal />
          </>
        ) : (
              <>
       
          {showConfirmModal && currentStep === 11 && (
            <Modal
              open={true}
              center
              onClose={cancelTourSwitch}
              showCloseIcon={false}
              classNames={{
                modal: "rounded-xl border-none shadow-2xl max-w-md w-full bg-white",
              }}
              styles={{
                modal: { 
                  zIndex: 100002,
                  backgroundColor: '#ffffff',
                  background: '#ffffff',
                  opacity: 1,
                }
              }}
            >
              <div className="p-6 text-center bg-white">
                <h2 className="text-xl font-semibold mb-4">{pendingNavigation?.message}</h2>
                <div className="flex gap-4 justify-center mt-6">
                  <BlackButton text="Skip" onClick={() => navigate('/dashboard/host/dashboard')} />
                  <PurpleButton text="Yes, Continue" onClick={() => confirmTourSwitch(navigate)} />
                </div>
              </div>
            </Modal>
          )}
          
        
          {isOnboarding && currentStep === 9 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99999] pointer-events-none" />
          )}
          
     
          {isOnboarding && currentStep === 10 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99999] pointer-events-none" />
          )}

          {/* Add backdrop for step 11 (trips overview) */}
          {isOnboarding && currentStep === 11 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99999] pointer-events-none" />
          )}
          
          <div className={`relative ${isOnboarding && currentStep === 9 ? 'ring-4 ring-purple-500 ring-opacity-50' : ''}`}>
            <StaticHostSidebar />
            
            {/* Step 9 Sidebar Onboarding Modal - Extra compact */}
            {isOnboarding && currentStep === 9 && (
              <div className="absolute top-16 left-[320px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="p-3">
                  <div className="text-center mb-3">
                    <h3 className="text-base font-semibold">Navigation Sidebar</h3>
                    <p className="text-xs text-[#666666] mt-1">Your menu for key features</p>
                  </div>

                  <div className="bg-purple-50 p-2 rounded-lg border border-purple-200 mb-3">
                    <div className="flex items-center gap-1 mb-1">
                      <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                      <div className="text-xs font-semibold text-purple-800">Host Navigation</div>
                    </div>
                    <div className="text-[10px] text-purple-700">
                      Your home base for hosting
                    </div>
                  </div>

                  <div className="space-y-1 mb-3">
                    <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
                      <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Dashboard</div>
                        <div className="text-[10px] text-[#666666]">Home base</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
                      <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Reservations</div>
                        <div className="text-[10px] text-[#666666]">Bookings</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 p-1.5 bg-yellow-50 rounded">
                      <div className="w-4 h-4 bg-yellow-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Transactions</div>
                        <div className="text-[10px] text-[#666666]">Payments</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 p-1.5 bg-red-50 rounded">
                      <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white">
                        <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                      </div>
                      <div>
                        <div className="text-xs font-semibold">Inbox</div>
                        <div className="text-[10px] text-[#666666]">Messages</div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-2 rounded border border-purple-200 mb-3">
                    <div className="flex items-center gap-1 mb-1">
                      <div className="w-2 h-2 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full"></div>
                      <div className="text-xs font-semibold text-purple-800">Role Switcher</div>
                    </div>
                    <div className="text-[10px] text-purple-700">
                      🔄 Switch Host/Traveler at bottom
                    </div>
                  </div>

                  {/* Purple arrow pointing to the sidebar */}
                  <div className="absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>

                  <div className="flex gap-1  justify-center">
                    {/* <BlackButton 
                      text="Back" 
                      onClick={() => {
                        navigate('/onboarding/steps'); 
                        prevStep();
                      }}
                      className="flex-1 text-xs py-1.5 px-2"
                    /> */}
                    <PurpleButton 
                      text="Next"
                      onClick={() => {
                        navigate('/onboarding/host1?step=11'); // Go to step 11 (verification)
                        nextStep();
                      }}
                      className="flex-1 text-xs py-1.5 px-2"
                    />
                    <button 
                      onClick={handleSkipOnboarding}
                      className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                    >
                      Skip
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="flex-1 select-none w-full overflow-auto max-h-[calc(100vh-80px)] h-full p-[10px]">
            <div className="w-full h-full space-y-[20px] rounded-[10px] p-[8px] flex flex-col">
              <div className="bg-white border-[2px] h-max border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                <div className="font-semibold text-[24px]">Dashboard</div>
                <div className="text-[#666666] font-normal">Welcome to the Coded Estate Dashboard</div>
              </div>

<div className="flex flex-col lg:flex-row gap-[12px] sm:gap-[20px] px-[6px] sm:px-[10px] w-full min-h-[240px]">
  <div className="mb-4 w-full lg:min-w-[300px] lg:w-[300px]">
              <div 
    id="verify-nfts-section"
    className={`w-full lg:min-w-[300px] lg:w-[300px] h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
      isOnboarding && currentStep === 10 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
    }`}
  >
                  <div className="font-semibold">Verify NFTs</div>
                  <div className={`bg-white flex flex-col justify-around p-2 items-center border-[2px] h-full w-full border-[#E3E3E3] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                    isOnboarding && currentStep === 10 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                  }`}>
                    {currentProfile?.Avatar ? (
                      <img
                        alt=""
                        src={currentProfile?.Avatar || "/placeholder.svg"}
                        className="w-[80px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      />
                    ) : (
                      <VerifyUserIcon />
                    )}
                    {currentProfile?.Name ? (
                      <div className="font-semibold">{currentProfile?.Name?.replace("/", " ")}</div>
                    ) : (
                      <div className="font-semibold">Unknown</div>
                    )}
                    {currentProfile?.isVerified ? (
                      <div className="flex items-center">
                        <Tick />
                        <div className="text-[#959595] font-normal text-[14px]">Verified Account</div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-[10px]">
                        <UnVerified />
                        <div className="text-[#959595] font-normal text-[14px]">Unverified Account</div>
                      </div>
                    )}
                    {currentProfile?.isVerified ? (
                      <div className="w-full">
                        <PurpleButton text={<div className="w-full text-center">Your Profile</div>} />
                      </div>
                    ) : (
                      <div className="w-full">
                        <BlackButton 
                          text={<div className="w-full text-center">Verify now</div>}
                          onClick={() => setShowVerificationModal(true)}
                        />
                      </div>
                    )}
                  </div>
                  
                  {/* Step 10 Onboarding Modal - Extra compact */}
                  {isOnboarding && currentStep === 10 && (
                    <div className="absolute top-0 left-[320px] w-[260px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                      <div className="p-3">
                        <div className="text-center mb-3">
                          <h3 className="text-base font-semibold">Profile Verification</h3>
                          <p className="text-xs text-[#666666] mt-1">Verify to start hosting</p>
                        </div>

                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-purple-800">Final Step!</div>
                          </div>
                          <div className="text-[10px] text-purple-700">
                            Profile Card shows verification status
                          </div>
                        </div>

                        <div className="space-y-2 mb-3">
                          <div className="bg-blue-50 p-2 rounded border border-blue-200">
                            <div className="flex items-center gap-1 mb-1">
                              <div className="w-3 h-3 bg-blue-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-[8px] font-bold">ℹ</span>
                              </div>
                              <div className="text-xs font-semibold text-blue-800">Profile</div>
                            </div>
                            <div className="text-[10px] text-blue-700">
                              Click "Verify now" to connect wallet
                            </div>
                          </div>

                          <div className="bg-yellow-50 p-2 rounded border border-yellow-200">
                            <div className="flex items-center gap-1 mb-1">
                              <div className="w-3 h-3 bg-yellow-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-[8px] font-bold">!</span>
                              </div>
                              <div className="text-xs font-semibold text-yellow-800">Required</div>
                            </div>
                            <div className="text-[10px] text-yellow-700">
                              Need for platform security
                            </div>
                          </div>
                        </div>

                        <div className="bg-green-50 p-2 rounded border border-green-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-green-800">You'll Need</div>
                          </div>
                          <div className="text-[10px] text-green-700 space-y-0.5">
                            <div>• Emirates ID</div>
                            <div>• Crypto wallet</div>
                            <div>• Personal info</div>
                          </div>
                        </div>

                        {/* Purple arrow pointing to the verification card */}
                        <div className="absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>

                        <div className="flex gap-1  justify-center">
                          <BlackButton 
                            text="Back" 
                            onClick={() => {
                              // Go back to step 9 in InstructionRental
                              navigate('/onboarding/host1?step=10');
                              setCurrentStep(9);
                            }}
                            className="flex-1 text-xs py-1.5 px-2"
                          />
                          <PurpleButton 
                            text="Next"
                            onClick={() => {
                              navigate('/onboarding/host1?step=12'); // Go to step 12 (trips overview)
                              nextStep();
                            }}
                     
                          />
                          <button 
                            onClick={()=>{navigate("/dashboard/host/dashboard")}}
                            className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                          >
                            Skip
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                </div>
    <div className="mb-9 relative w-full lg:w-max lg:max-w-[calc(50vw-500px)]">
             <div className={`relative w-full lg:w-max lg:max-w-[calc(50vw-500px)] h-full flex flex-col space-y-[8px] sm:space-y-[10px] ${
    isOnboarding && currentStep === 14 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
  }`}>
                  <div className="font-semibold">Your Minted NFTs</div>
                  <div className="w-full min-h-[200px] max-h-[280px] bg-white p-2 border-[2px] border-[#E3E3E3] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] overflow-hidden">
                    <div className="pb-1 flex gap-[10px] items-center overflow-auto scrollbarwidth w-full h-full">
                      {myNfts.map((nft, i) => (
                        <div key={i} className="w-max h-max relative group">
                          <RentalItem
                            showArrow={false}
                            token_id={nft.token_id}
                            tokenData={nft}
                            imageHeight={200}
                            onlyImages
                          />
                          <div className="group-hover:flex absolute top-0 left-0 w-full h-full hidden flex-col items-center justify-center">
                            <BlackButton text="View" />
                          </div>
                        </div>
                      ))}
                    </div>
                    {myNfts.length === 0 && (
                      <div className="flex flex-col justify-center items-center h-full w-full px-[100px] text-center">
                        <EmptyProperty />
                        <div className="font-semibold">You have no properties yet</div>
                      </div>
                    )}
                  </div>
                {isOnboarding && currentStep === 14 && !showCompletionModal && (
  <div className="absolute top-0 left-[380px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Your Minted NFTs</h3>
        <p className="text-xs text-[#666666] mt-1">
          Here your minted properties will be seen Mint your property NFT and start hosting
        </p>
      </div>
      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Mint Property</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Minting an NFT lets you list your property on CodedEstate and unlock hosting features
        </div>
      </div>
      <div className="space-y-1 mb-3">
        <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
          <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Start Hosting</div>
            <div className="text-[10px] text-[#666666]">Mint your property and begin earning</div>
          </div>
        </div>
        <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
          <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
            <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div>
            <div className="text-xs font-semibold">Direct Ownership</div>
            <div className="text-[10px] text-[#666666]">Control your assets securely</div>
          </div>
        </div>
      </div>
      {/* Purple arrow pointing to the Minted NFTs section */}
      <div className="absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
      <div className="flex gap-1  justify-center">
        <BlackButton 
          text="Back" 
          onClick={() => {
            setCurrentStep(13);
            navigate('/onboarding/host1?step=13');
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
       <PurpleButton 
  text="Next"
 onClick={() => {
navigate('/onboarding/host1?step=15');
  }}

/>
      </div>
    </div>
  </div>
)}
                </div>
</div>

  <div className="mb-9 relative h-full w-full lg:max-w-[calc(50vw-200px)] lg:w-max">
                <div className={`relative h-full w-full lg:max-w-[calc(50vw-200px)] lg:w-max flex flex-col space-y-[8px] sm:space-y-[10px] ${
    isOnboarding && currentStep === 11 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
  }`}>
                  <div className="font-semibold">Booking request</div>
                  <div className={`border-[2px] border-[#E3E3E3] h-full bg-white p-2 top-0 overflow-auto w-full rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                    isOnboarding && currentStep === 11 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                  }`}>
                    <div className="w-full min-w-[calc(50vw-240px)] justify-between flex items-center gap-4">
                      <SelectionGroup
                        defaultItem={flag}
                        className={`border-[2px] border-[#e3e3e3] w-max px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                          isOnboarding && currentStep === 11 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                        }`}
                      >
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Upcoming</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Upcoming</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Current</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Current</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Completed</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Completed</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Cancelled</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Cancelled</div>
                            </div>
                          }
                        />
                      </SelectionGroup>
                    </div>
                    <div className="flex gap-2 items-center mt-1 pb-1 w-full overflow-auto scrollbarwidth">
                      <div className="flex flex-col items-center w-full justify-center h-full">
                        <EmptyBooking />
                        <div>No reservations yet</div>
                        <div className="text-[#737373]">No upcoming reservations yet</div>
                      </div>
                    </div>
                  </div>

                  {/* Step 11 Trips Overview Onboarding Modal */}
                  {isOnboarding && currentStep === 11 && !showConfirmModal && (
                    <div className="absolute top-0 -left-[300px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                      <div className="p-3">
                        <div className="text-center mb-3">
                          <h3 className="text-base font-semibold">Booking Management</h3>
                          <p className="text-xs text-[#666666] mt-1">Track all your reservations</p>
                        </div>

                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-purple-800">Booking Management</div>
                          </div>
                          <div className="text-[10px] text-purple-700">
                            Center panel includes tabs for all your reservations
                          </div>
                        </div>

                        <div className="space-y-1 mb-3">
                          <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
                            <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
                              <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                              </svg>
                            </div>
                            <div>
                              <div className="text-xs font-semibold">Upcoming</div>
                              <div className="text-[10px] text-[#666666]">View your next booked stays</div>
                            </div>
                          </div>
                          
                          <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
                            <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
                              <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
                              </svg>
                            </div>
                            <div>
                              <div className="text-xs font-semibold">Current</div>
                              <div className="text-[10px] text-[#666666]">See ongoing reservations</div>
                            </div>
                          </div>
                          
                          <div className="flex items-center gap-2 p-1.5 bg-gray-50 rounded">
                            <div className="w-4 h-4 bg-gray-500 rounded-full flex items-center justify-center text-white">
                              <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                              </svg>
                            </div>
                            <div>
                              <div className="text-xs font-semibold">Completed</div>
                              <div className="text-[10px] text-[#666666]">Review past stays</div>
                            </div>
                          </div>
                          
                          <div className="flex items-center gap-2 p-1.5 bg-red-50 rounded">
                            <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white">
                              <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path>
                              </svg>
                            </div>
                            <div>
                              <div className="text-xs font-semibold">Cancelled</div>
                              <div className="text-[10px] text-[#666666]">Access booking history</div>
                            </div>
                          </div>
                        </div>

                        <div className="bg-green-50 p-2 rounded border border-green-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-green-800">Travel Activity</div>
                          </div>
                          <div className="text-[10px] text-green-700">
                            This is where you'll track all your travel activity on the platform
                          </div>
                        </div>

                        {/* Purple arrow pointing to the booking request section */}
                        <div className="absolute top-1/2 -right-4 w-0 h-0 border-l-[16px] border-t-[12px] border-b-[12px] border-l-purple-500 border-t-transparent border-b-transparent"></div>

                        <div className="flex gap-1  justify-center">
                          <BlackButton 
                            text="Back" 
                            onClick={() => {
                              navigate('/onboarding/host1?step=11');
                              prevStep();
                            }}
                            className="flex-1 text-xs py-1.5 px-2"
                          />
                          <PurpleButton 
                            text="Next"
                            onClick={()=>{navigate('/onboarding/host1?step=13');
                              nextStep();
                            }}
                            
                          />
                        
                        </div>
                      </div>
                    </div>
                  )}
                </div>
</div>

              </div>

    <div className="flex flex-col lg:flex-row gap-[12px] sm:gap-[20px] px-[6px] sm:px-[10px] w-full min-h-[300px]">
  <div className="mb-4 w-full lg:min-w-[40%]">
 <div className={`w-full lg:min-w-[40%] h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
    isOnboarding && currentStep === 13
      ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50 onboarding-highlight'
      : ''
  }`}>
  <div className="font-semibold">Mint Your Real Estate NFT</div>
  <div className="bg-white flex flex-col justify-around items-center border-[2px] h-[220px] sm:h-[300px] w-full border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
    <EmptyNft />
    <div className="flex flex-col items-center">
      <div className="font-semibold">No NFT's minted yet</div>
      <div className="text-[#959595] font-normal text-[14px]">Your NFT minted is empty yet</div>
    </div>
    <PurpleButton text={<div className="min-w-[100px] text-center">Mint</div>} />
  </div>
  {/* Step 13 Onboarding Modal */}
  {isOnboarding && currentStep === 13 && (
    <div className="absolute top-0 left-[380px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
      <div className="p-3">
        <div className="text-center mb-3">
          <h3 className="text-base font-semibold">Mint Your Real Estate NFT</h3>
          <p className="text-xs text-[#666666] mt-1">Mint your property NFT and start hosting</p>
        </div>
        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
          <div className="flex items-center gap-1 mb-1">
            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
            <div className="text-xs font-semibold text-purple-800">Mint Property</div>
          </div>
          <div className="text-[10px] text-purple-700">
            Minting an NFT lets you list your property on CodedEstate and unlock hosting features
          </div>
        </div>
        <div className="space-y-1 mb-3">
          <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
            <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
              <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 2L3 7v11a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V7l-7-5z"></path>
              </svg>
            </div>
            <div>
              <div className="text-xs font-semibold">Start Hosting</div>
              <div className="text-[10px] text-[#666666]">Mint your property and begin earning</div>
            </div>
          </div>
          <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
            <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
              <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div>
              <div className="text-xs font-semibold">Direct Ownership</div>
              <div className="text-[10px] text-[#666666]">Control your assets securely</div>
            </div>
          </div>
        </div>
        {/* Arrow pointing to Mint button */}
        <div className="absolute top-[120px] -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
        <div className="flex gap-1  justify-center">
          <BlackButton 
            text="Back" 
            onClick={() => {
              setCurrentStep(11);
              navigate('/onboarding/host1?step=12');
            }}
            className="flex-1 text-xs py-1.5 px-2"
          />
          <PurpleButton 
            text="Next"
            onClick={()=>{navigate("/onboarding/host1?step=14")}}
            
          />
        </div>
      </div>
    </div>
  )}
</div>
</div>

 <div className="mb-4 w-full">

<div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
  isOnboarding && currentStep === 15
    ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50 bg-purple-50'
    : ''
}`}>
  <div className="font-semibold">Notifications</div>
  {notificationContent.length > 0 ? (
    <div className="bg-white space-y-[4px] border-[2px] h-full w-full overflow-auto border-[#E3E3E3] p-[8px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] scrollbarwidth">
      {notificationContent.map((notif, idx) => (
        <div key={idx} className="flex items-center justify-between p-2 border-b last:border-b-0">
          {/* Render your notification item here */}
          <div>
            {notif.type === "event" ? (
              <span>
                {profiles[notif.data.sender]?.Name || notif.data.sender} {parseAction(notif.data.action)}
              </span>
            ) : (
              <span>
                {profiles[notif.data.message.sender]?.Name || notif.data.message.sender} Sent new message
              </span>
            )}
          </div>
          <div className="text-xs text-gray-500">
            {notif.type === "event"
              ? formatDate(notif.data.timeUTC) + " " + formatTime(notif.data.timeUTC)
              : formatDate(notif.data.message.generatedTime) + " " + formatTime(notif.data.message.generatedTime)}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="bg-white flex flex-col justify-around items-center border-[2px] h-[220px] sm:h-[300px] w-full border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
      <EmptyInbox />
      <div className="flex flex-col items-center">
        <div className="font-semibold">No notifications yet</div>
        <div className="text-[#959595] font-normal text-[14px]">Your inbox is empty yet</div>
      </div>
      <PurpleButton text={<div className="min-w-[100px] text-center">Inbox</div>} />
    </div>
  )}

{isOnboarding && currentStep === 15 && !showCompletionModal && (
  <div className="absolute top-0 left-[-300px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[100000] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Notifications</h3>
        <p className="text-xs text-[#666666] mt-1">
          All your platform notifications, messages, and updates will appear here. Stay informed about bookings, messages, and platform alerts
        </p>
      </div>
      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Stay Updated</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Check this panel regularly for important updates and guest messages
        </div>
      </div>
      <div className="absolute top-1/2 -right-4 w-0 h-0 border-l-[16px] border-t-[12px] border-b-[12px] border-l-purple-500 border-t-transparent border-b-transparent"></div>
      <div className="flex gap-1">
        <BlackButton 
          text="Back" 
          onClick={() => {
            setCurrentStep(14);
            navigate('/onboarding/host1?step=14');
          }}
          className="flex-1 text-xs py-1.5 px-2"
        />
        <PurpleButton 
          text="Complete"
          onClick={() => {
            setCurrentStep(null);
            setShowCompletionModal(true);
          }}
     
        />
      </div>
    </div>
  </div>
)}
</div>
</div>

              </div>
            </div>
          </div>
          
       
      {showCompletionModal && (
  <>
    <style>{`
      .react-responsive-modal-overlay.transparent-overlay,
      .react-responsive-modal-overlay {
        background-color: transparent !important;
        background: transparent !important;
        opacity: 0 !important;
      }
    `}</style>
    <Modal
      open={true}
      center
      onClose={() => setShowCompletionModal(false)}
      showCloseIcon={false}
      classNames={{
        modal: "rounded-xl border-none shadow-2xl max-w-md w-full bg-white",
        overlay: "transparent-overlay"
      }}
      styles={{
        modal: { 
          zIndex: 100002,
          backgroundColor: '#ffffff',
          background: '#ffffff',
          opacity: 1,
        },
        overlay: {
          backgroundColor: 'transparent !important',
          background: 'transparent !important',
          opacity: '0 !important',
        }
      }}
    >
    <div className="p-6 text-center bg-white">
      <h2 className="text-xl font-semibold mb-4">Do you want to start hosting properties?</h2>
      <div className="flex gap-4 justify-center mt-6">
        <BlackButton 
          text="Complete Onboarding" 
          onClick={() => {
            setShowCompletionModal(false);
            // Save the last step before navigating to completion
            sessionStorage.setItem('hostOnboardingLastStep', '15');
            sessionStorage.setItem('hostOnboardingFromCompletion', 'true');
            completeOnboarding();
            navigate('/rent/onboarding/Completion');
          }} 
        />
        <PurpleButton 
          text="Start Hosting" 
          onClick={() => {
            setShowCompletionModal(false);
            // Save the last step before navigating
            sessionStorage.setItem('hostOnboardingLastStep', '15');
            sessionStorage.setItem('hostOnboardingFromCompletion', 'true');
            navigate('/dashboard/host/dashboard'); // Change this route to your actual hosting dashboard
          }} 
        />
      </div>
    </div>
  </Modal>
  </>
)}

          <VerificationModal />
        </>
        )}
      
          
       

        </>
      )}
    </div>
  );
};



export { HostDashboard1 as StaticHostDashboard1 };
